import React from 'react';
import { memoize } from 'react-data-table-component';
import { Edit2, Trash } from 'react-feather';
import { Button } from 'react-bootstrap';

const columnsAdmin = memoize(clickHandler => [
  {
    name: 'NOMBRE',
    selector: 'quiz.name'
  },
  {
    name: 'AÑO',
    selector: 'quiz.year'
  },
  {
    name: 'SECCIÓN',
    selector: 'section.full_name',
    right: true
  },
  {
    name: 'ESTABLECIMIENTO',
    selector: 'section.establishment_name',

    right: true
  },
  {
    cell: infoItem => (
      <div>
        <Button
          variant="outline-primary"
          size="sm"
          className="mr-2"
          onClick={() => clickHandler(infoItem, 'edit')}
        >
          <Edit2 className="small-svg" />
        </Button>
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => clickHandler(infoItem, 'delete')}
        >
          <Trash className="small-svg" />
        </Button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true
  }
]);

const columns = memoize(clickHandler => [
  {
    name: 'NOMBRE',
    selector: 'quiz.name'
  },
  {
    name: 'AÑO',
    selector: 'quiz.year'
  },
  {
    name: 'SECCIÓN',
    selector: 'section.full_name',
    right: true
  },
  {
    name: 'ESTABLECIMIENTO',
    selector: 'section.establishment_id',

    right: true
  },
  {
    cell: infoItem => (
      <div>
        <Button
          variant="outline-primary"
          size="sm"
          className="mr-2"
          onClick={() => clickHandler(infoItem, 'edit')}
        >
          <Edit2 className="small-svg" />
        </Button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true
  }
]);

export { columns, columnsAdmin };
